// extracted by mini-css-extract-plugin
export default {"ShowAsUserButton":"ShowAsUserButton_ShowAsUserButton__KZxst"};